module.exports = __webpack_public_path__ + "/content/skins/manheim/fav//manifest.json";